'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var DisclaimerText = require('@narvar/nth-block-notification-center-disclaimer-text');
var PanelContentHeader = require('@narvar/nth-block-panel-content-header');
var nthKitDynamicLayoutNext = require('@narvar/nth-kit-dynamic-layout-next');
var OptinTemplate_module = require('./OptinTemplate.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var DisclaimerText__default = /*#__PURE__*/_interopDefaultLegacy(DisclaimerText);
var PanelContentHeader__default = /*#__PURE__*/_interopDefaultLegacy(PanelContentHeader);

const {
  FeatureLayout
} = nthKitDynamicLayoutNext.LayoutTree;
const OptInTemplate = ({
  featureName,
  layout,
  channel,
  notificationPreferencesState,
  optInChannelProps: {
    optInIcon,
    optInMessageText,
    optInChannelInput,
    landscapeColWidths
  },
  consumerPreferencesOptinEnabled
}) => {
  const isLandscape = layout === FeatureLayout.LANDSCAPE;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: OptinTemplate_module["default"].optinContainer,
    "data-test": `${channel}NotificationCenterOptIn`
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    "data-testid": `column-one-${isLandscape ? '6' : '12'}`,
    style: {
      gridColumn: `span ${isLandscape ? (landscapeColWidths && landscapeColWidths[0]) ?? '6' : '12'}`
    }
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: isLandscape ? OptinTemplate_module["default"].panelContainerLandscape : OptinTemplate_module["default"].panelContainer
  }, /*#__PURE__*/React__default["default"].createElement(PanelContentHeader__default["default"], {
    as: "p",
    featureName: featureName,
    icon: optInIcon,
    headerText: optInMessageText || '',
    isLandscape: isLandscape
  })), isLandscape && !consumerPreferencesOptinEnabled && /*#__PURE__*/React__default["default"].createElement("div", {
    className: OptinTemplate_module["default"].disclaimerContainerLandscape,
    "data-test": `${channel}DisclaimerTextContainer`
  }, /*#__PURE__*/React__default["default"].createElement(DisclaimerText__default["default"], {
    featureName: featureName,
    notificationChannel: channel,
    notificationPreferencesState: notificationPreferencesState,
    consumerPreferencesOptinEnabled: consumerPreferencesOptinEnabled
  }))), /*#__PURE__*/React__default["default"].createElement("div", {
    "data-testid": `column-two-${isLandscape ? '6' : '12'}`,
    style: {
      gridColumn: `span ${isLandscape ? (landscapeColWidths && landscapeColWidths[0]) ?? '6' : '12'}`
    }
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: isLandscape ? OptinTemplate_module["default"].inputContainerLandscape : OptinTemplate_module["default"].inputContainer
  }, optInChannelInput)), !isLandscape && !consumerPreferencesOptinEnabled && /*#__PURE__*/React__default["default"].createElement("div", {
    className: OptinTemplate_module["default"].disclaimerContainer,
    "data-test": `${channel}DisclaimerTextContainer`
  }, /*#__PURE__*/React__default["default"].createElement(DisclaimerText__default["default"], {
    featureName: featureName,
    notificationChannel: channel,
    notificationPreferencesState: notificationPreferencesState,
    consumerPreferencesOptinEnabled: consumerPreferencesOptinEnabled
  })));
};

exports["default"] = OptInTemplate;
